import { render, staticRenderFns } from "./PopupSendEmailComponent.vue?vue&type=template&id=1251f246&scoped=true"
import script from "./PopupSendEmailComponent.vue?vue&type=script&lang=js"
export * from "./PopupSendEmailComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupSendEmailComponent.vue?vue&type=style&index=0&id=1251f246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251f246",
  null
  
)

export default component.exports